import { Button } from '@/components/ui/button'
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '@/components/ui/dialog'

/**
 * Shown when a form configured with "Create Product" reaches Complete Form
 * without a product ever having been created. "Skip" completes the form
 * anyway (the gate is advisory, not a hard block) — see completeTrigger on
 * FormRenderer for how the parent re-drives completion after this closes.
 */
export function ProductNotCreatedDialog({
  open,
  onClose,
  onCreateProduct,
  onSkip,
}: {
  open: boolean
  onClose: () => void
  onCreateProduct: () => void
  onSkip: () => void
}) {
  return (
    <Dialog open={open} onOpenChange={o => !o && onClose()}>
      <DialogContent className='sm:max-w-sm'>
        <DialogHeader>
          <DialogTitle>Product not created</DialogTitle>
          <DialogDescription>
            Create New Product is configured for this form and it is not created. Click add to
            create a new product, or click skip to complete the process and close the form.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant='outline' onClick={onSkip}>
            Skip
          </Button>
          <Button onClick={onCreateProduct}>+ Create New Product</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
